"use client";

import React, { useState } from "react";
import {
  Box,
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import { useTranslation } from "react-i18next";

const ChannelsToolbar = ({ onCreateNew, onMapWithAi }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation("settings");
  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);

  const btnSx = {
    height: 40,
    borderRadius: 2,
    textTransform: "none",
    whiteSpace: "nowrap",
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 1,
        width: isMobile ? "100%" : "auto",
        flexWrap: "nowrap",
      }}
    >
      <Button
        variant="outlined"
        startIcon={<MoreVertRoundedIcon />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        fullWidth={isMobile}
        sx={btnSx}
      >
        {t("channelsPage.toolbar.actions")}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { borderRadius: 2, minWidth: 280 } }}
      >
        <MenuItem disabled dense sx={{ opacity: 1, cursor: "default" }}>
          <Typography variant="caption" color="text.secondary">
            {t("channelsPage.toolbar.groupIntelligence")}
          </Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            onMapWithAi?.();
          }}
        >
          <ListItemIcon>
            <AutoAwesomeRoundedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary={t("channelsPage.toolbar.mapWithAi")}
            secondary={t("channelsPage.toolbar.mapWithAiHint")}
          />
        </MenuItem>
      </Menu>
      {onCreateNew ? (
        <Button
          startIcon={<AddRoundedIcon />}
          variant="contained"
          color="primary"
          onClick={onCreateNew}
          fullWidth={isMobile}
          sx={{ ...btnSx, boxShadow: "none", px: 2 }}
        >
          {t("channelsPage.addChannel")}
        </Button>
      ) : null}
    </Box>
  );
};

export default ChannelsToolbar;
